(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      // theme.initAnimateOnScroll();
      // $('.product-form', productRecommendationsSection).trigger('load-product-form');

      setTimeout(()=>{
        $(".product-recommendations .product-block").each(function(){
          theme.initProductGallery($(this)); // 1
          $(this).find('.product-form').
            trigger('load-product-form'); // 2
            // loadComponents($(this)); // 3
            theme.initAnimateOnScroll();
        })
        theme.loadCarousels(productRecommendationsSection);
      },500)
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss26-brand-muse-introducing"] && !Shopify.designMode) return;
  try {
    
(function() {
  function init(root) {
    if (!root) return;

    const video = root.querySelector("video");
    const button = root.querySelector("button");

    if (!video || !button || button.dataset.bound) return;
    button.dataset.bound = "true";

    const unmuteText = button.dataset.unmuteText || "Tap to Unmute";
    const muteText = button.dataset.muteText || "Tap to Mute";

    video.muted = true;
    button.textContent = unmuteText;

    video.play().catch(() => {});

    button.addEventListener("click", () => {
      if (video.muted) {
        video.muted = false;
        video.volume = 1;
        video.play().catch(() => {});
        button.textContent = muteText;
      } else {
        video.muted = true;
        button.textContent = unmuteText;
      }
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("section[class*='bonia-editorial-']").forEach(init);
  });

  document.addEventListener("shopify:section:load", (event) => {
    init(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-with-live-countdown"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initVideoCountdown(root) {
    if (!root) return;

    const video = root.querySelector('video');
    const button = root.querySelector('button[class*="ai-video-overlay-center-button"]');
    const countdown = root.querySelector('[class*="ai-video-overlay-countdown"]');
    const datetimeRaw = root.dataset.countdownDatetime || "";

    if (video) {
      video.muted = true;
      video.play().catch(() => {});
    }

    if (video && button && !button.dataset.bound) {
      button.dataset.bound = "true";

      const unmuteText = button.dataset.unmuteText || "Tap to Unmute";
      const muteText = button.dataset.muteText || "Tap to Mute";

      button.textContent = unmuteText;

      button.addEventListener('click', () => {
        if (video.muted) {
          video.muted = false;
          video.play().catch(() => {});
          button.textContent = muteText;
        } else {
          video.muted = true;
          button.textContent = unmuteText;
        }
      });
    }

    if (countdown && !countdown.dataset.timerBound) {
      countdown.dataset.timerBound = "true";

      const daysEl = countdown.querySelector('[data-days]');
      const hoursEl = countdown.querySelector('[data-hours]');
      const minutesEl = countdown.querySelector('[data-minutes]');
      const secondsEl = countdown.querySelector('[data-seconds]');

      function getMalaysiaNowTimestamp() {
        const now = new Date();
        const mytString = now.toLocaleString("en-US", { timeZone: "Asia/Kuala_Lumpur" });
        return new Date(mytString).getTime();
      }

      function fallbackTarget() {
        const now = new Date();
        const year = new Intl.DateTimeFormat("en-US", {
          timeZone: "Asia/Kuala_Lumpur",
          year: "numeric"
        }).format(now);

        let target = new Date(`${year}-01-02T00:00:00+08:00`).getTime();
        const nowMYT = getMalaysiaNowTimestamp();
        if (target - nowMYT <= 0) {
          target = new Date(`${parseInt(year, 10) + 1}-01-02T00:00:00+08:00`).getTime();
        }
        return target;
      }

      function parseTargetTimestampMalaysia(datetimeString) {
        if (!datetimeString) return fallbackTarget();
        const clean = datetimeString.trim().replace(" ", "T");
        const withZone = clean + ":00+08:00";
        const parsed = new Date(withZone).getTime();
        if (isNaN(parsed)) return fallbackTarget();
        return parsed;
      }

      const targetTimestamp = parseTargetTimestampMalaysia(datetimeRaw);

      function updateCountdown() {
        const nowTimestamp = getMalaysiaNowTimestamp();
        let diff = targetTimestamp - nowTimestamp;
        if (diff < 0) diff = 0;

        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((diff / (1000 * 60)) % 60);
        const seconds = Math.floor((diff / 1000) % 60);

        if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
        if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
        if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
        if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');
      }

      updateCountdown();
      setInterval(updateCountdown, 1000);
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll('[data-section-id]').forEach(initVideoCountdown);
  });

  document.addEventListener("shopify:section:load", (event) => {
    initVideoCountdown(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
